module.exports = __webpack_public_path__ + "static/media/07A.e3a0a6ce.png";